export default "<input type=\"checkbox\" class=\"leva-form-control\" [(ngModel)]=\"params.value\" (ngModelChange)=\"onValueChanged($event)\" />\n"